import React from "react";
import 'react-quill/dist/quill.snow.css';
import ReactQuill from 'react-quill';
import PropTypes from 'prop-types';

class EmailTemplateBodyEditor extends React.Component {
    constructor(props) {
        super(props)
    }

    componentDidMount() {
        const placeholderPickerItems = Array.prototype.slice.call(document.querySelectorAll('.ql-placeholder .ql-picker-item'));

        placeholderPickerItems.forEach(item => {
            item.textContent = item.dataset.value

            let match = this.props.placeholders.find(e => e.value === item.dataset.value);
            if (match) {
                item.innerHTML = match.text;
            }
        });

        const placeholderLabel = document.querySelector('.ql-placeholder .ql-picker-label');

        placeholderLabel.innerHTML = 'Auto Text' + placeholderLabel.innerHTML;
        placeholderLabel.style.paddingRight = "20px";
    }

    /* 
 * Quill modules to attach to editor
 * See http://quilljs.com/docs/modules/ for complete options
 */
    modules = {
        toolbar: {
            container:
            [
                [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
                ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
                [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                [{ 'align': [] }],
                [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
    
                [{ 'placeholder': this.props.placeholders.map(p => p.value) }], // my custom dropdown
                
                ['clean']                                    // remove formatting button
               
            ],
            handlers: {
                "placeholder": function (value) { 
                    if (value) {
                        const cursorPosition = this.quill.getSelection().index;
                        this.quill.insertText(cursorPosition, value);
                        this.quill.setSelection(cursorPosition + value.length);
                    }
                }
            }
        }
    }

    render() {
        return (
            <div className="text-editor">
                <ReactQuill
                    theme={'snow'}
                    onChange={this.props.handleChange}
                    value={this.props.value}
                    modules={this.modules}
                    placeholder={this.props.placeholder}
                />
            </div>

        )
    }
}


/* 
 * PropType validation
 */
EmailTemplateBodyEditor.propTypes = {
    placeholder: PropTypes.string,
    onChange: PropTypes.func,
    value: PropTypes.string,
    placeholders: PropTypes.array
}

export default EmailTemplateBodyEditor;